import AppPortal from "../AppPortal";
import "./AppTooltip.css";

export default function AppTooltip({
  text,
  position,
  isIcon = false
}: {
  text: React.ReactNode;
  position: { x: number; y: number };
  isIcon?: boolean;
}) {
  if (!text) return null;

  const transformStyle = isIcon
  ? "translate(-100%, -100%)"
  : "translate(-50%, -100%)";

  return (
    <AppPortal>
      <div
        className={`app-tooltip ${isIcon ? "icon-tooltip" : ""}`}
        style={{
          position: "fixed",
          top: position.y,
          left: position.x,
          transform: transformStyle,
        }}
      >
        {text}
      </div>
    </AppPortal>
  );
}
